import React from 'react';
import PropTypes from 'prop-types';
import useAllowedAccess from './useAllowedAccess';
import Error403 from 'pages/errorPages/Error403';

const AllowedAccess = ({
  permissionIds = [],
  children,
  isPageFailed,
  forceToFailed,
}) => {
  const canAccess = useAllowedAccess(permissionIds);
  if (forceToFailed) {
    return <Error403 />;
  }
  return canAccess ? <>{children}</> : <>{isPageFailed ? <Error403 /> : ''}</>;
};

export default React.memo(AllowedAccess);

AllowedAccess.propTypes = {
  permissionIds: PropTypes.array,
  children: PropTypes.element,
  isPageFailed: PropTypes.bool,
  forceToFailed: PropTypes.bool,
};
